// extracted by mini-css-extract-plugin
module.exports = {"selectedWrapTitle":"tab_selectedWrapTitle__LFKGl","notSelectWrapTitle":"tab_notSelectWrapTitle__2D8uz","iconNew":"tab_iconNew__1l_vQ"};